import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { storage } from '../../../config';

import TabToggle from '../../TabToggle/TabToggle';
import FlipCardContainer from '../../FlipCard/FlipCardContainer';
import FlipCard from '../../FlipCard/FlipCard';
import AreaWorkforce from '../../Areas/AreaWorkforce/AreaWorkforce';
import PropertyDetailAreaInformationHeader from '../PropertyDetailAreaInformation//PropertyDetailAreaInformationHeader';
import PropertyDetailAreaDetails from '../PropertyDetailAreaDetail/PropertyDetailAreaDetails';
import PropertyDetailAreaOverview from '../PropertyDetailAreaOverview/PropertyDetailAreaOverview';
import { ViewerPrimaryColorUserStyle } from '../../UserCustomization';
import { capitalize } from '../../../utils/format';

import './PropertyDetailAreaInformation.css';

export class PropertyDetailAreaInformationComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detailMenuLength: 0,
      showWorkforceData: false,
      activeTab: 'overview',
    };
    this.handleToggleClick = this.handleToggleClick.bind(this);
    this.setDetailMenuLength = this.setDetailMenuLength.bind(this);
    this.handleWorkforceClick = this.handleWorkforceClick.bind(this);
  }

  componentWillMount() {
    const { layer, organizationId, location, area, getAreas } = this.props;
    const updatedLocation = layer === 'regions'
    ? { ...location, countyName: capitalize(location.countyName.toLowerCase()) }
    : { ...location };
    let fetchAreas = false;
    const hasArea = area !== undefined && area._id !== '' && area._id !== undefined && area._id !== null;
    if (!hasArea) {
      fetchAreas = true;
    } else if (layer === 'states' && area.state_cd !== location.state) {
      fetchAreas = true;
    } else if (layer === 'counties' && area.intid !== location.county) {
      fetchAreas = true;
    } else if (layer === 'communities' && area.intid !== location.community) {
      fetchAreas = true;
    } else if (layer === 'regions' && area.counties && !area.counties.some(county => county.name === capitalize(location.countyName.toLowerCase()))) {
      fetchAreas = true;
    }
    if (fetchAreas) {
      getAreas(layer, organizationId, updatedLocation);
    }
  }

  setDetailMenuLength(menuLength) {
    this.setState({ detailMenuLength: menuLength });
  }

  handleToggleClick(tab) {
    this.setState({ activeTab: tab });
  }

  handleWorkforceClick({ cancel = false } = {}) {
    this.setState({ showWorkforceData: !cancel });
  }

  buildAreaDetail = () => {
    const { area, layer, detailInfoToShow, overview } = this.props;
    const flip = this.state.activeTab === 'details';
    const hasWorkforceData = overview[layer].details && overview[layer].details.laborForceUrls;
    return (this.state.showWorkforceData && hasWorkforceData)
      ?
        <AreaWorkforce
          occupationUrl={overview[layer].details.laborForceUrls.occupationUrl}
          industryUrl={overview[layer].details.laborForceUrls.industryUrl}
          onCancel={() => {
            this.handleWorkforceClick({ cancel: true });
          }}
        />
      : (
        <div className="detail-content">
          <div className="detail-toggle">
            <TabToggle
              handleClick={this.handleToggleClick}
              name="detailToggle"
              checked={flip}
              leftTab="Overview"
              rightTab="Details"
              subTab={this.state.activeTab}
              detailMenuLength={this.state.detailMenuLength}
              shouldShowRightTab={this.state.detailMenuLength > 0}
            />

            {hasWorkforceData &&
              <div className="workforce-btn">
                <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
                  <a
                    className="btn"
                    tabIndex="0"
                    onClick={() => {
                      this.handleWorkforceClick();
                    }}
                  >
                    Workforce
                  </a>
                </ViewerPrimaryColorUserStyle>
              </div>
            }
          </div>
          <FlipCardContainer flip={flip} transform>
            <FlipCard side="front">
              <PropertyDetailAreaOverview
                area={area}
                overview={overview[layer]}
                layer={layer}
              />
            </FlipCard>
            <FlipCard side="back">
              <PropertyDetailAreaDetails
                detailMenuLength={this.state.detailMenuLength}
                setDetailMenuLength={this.setDetailMenuLength}
                overview={overview[layer]}
                detailInfoToShow={detailInfoToShow}
                area={area}
                layer={layer}
              />
            </FlipCard>
          </FlipCardContainer>
        </div>
      );
  }

  render() {
    const {
      handleModalClick,
      overview,
      area,
      organizationId,
      layer,
      showShareModal,
      showSlideshow,
      showDownloadModal,
      showSpecialDownloadModal,
      showModal,
      viewer,
      areasLoading,
      loadingProperty,
    } = this.props;

    return (
      <div className={`property-detail-area-wrapper area-${layer}`}>
        {areasLoading && (
          <div style={{ padding: 20 }}>
            <img
              alt="loading gif"
              src={`${storage.distPath}/loading.gif`}
            />
          </div>
        )}
        {!areasLoading && !loadingProperty &&
          <div className="building-detail detail-wrapper animate__animated animate__fadeIn">
            {area === undefined &&
              <div>
                Area data for {layer} could not be retrieved for this property.<br /><br />
              </div>
            }
            {area &&
              <PropertyDetailAreaInformationHeader
                handleModalClick={handleModalClick}
                handleWorkforceClick={this.handleWorkforceClick}
                area={area}
                overview={overview[layer]}
                layer={layer}
                organizationId={organizationId}
                showShareModal={showShareModal}
                showSlideshow={showSlideshow}
                showDownloadModal={showDownloadModal}
                showSpecialDownloadModal={showSpecialDownloadModal}
                showModal={showModal}
                viewer={viewer}
              />
            }
            {area && this.buildAreaDetail() }
          </div>
        }
      </div>
    );
  }
}

PropertyDetailAreaInformationComponent.propTypes = {
  getAreas: PropTypes.func,
  area: PropTypes.shape({
    name: PropTypes.string,
    polygon: PropTypes.object,
  }),
  overview: PropTypes.object,
  organizationId: PropTypes.string,
  layer: PropTypes.string.isRequired,
  location: PropTypes.object,
  handleModalClick: PropTypes.func,
  showShareModal: PropTypes.func,
  showSlideshow: PropTypes.func,
  showDownloadModal: PropTypes.func,
  showSpecialDownloadModal: PropTypes.func,
  showModal: PropTypes.func,
  detailInfoToShow: PropTypes.arrayOf(PropTypes.string),
  viewer: PropTypes.object.isRequired,
  areasLoading: PropTypes.bool,
  loadingProperty: PropTypes.bool,
};

export const mapStateToProps = (state, { type, layer }) => {
  return {
    area: state[type].areaActive[layer],
    overview: state[type].areasOverview,
  };
};

export default connect(mapStateToProps, null)(PropertyDetailAreaInformationComponent);



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/PropertyDetailAreaInformation/PropertyDetailAreaInformation.js